module.exports = __webpack_public_path__ + "images/nationalenederlanden_smalla12acf1974ed24457d2dcab992bb3e6c.png";